const SET_ONBOARDING_MODAL = 'SET_ONBOARDING_MODAL'
const SET_ONBOARDING_ITEM = 'SET_ONBOARDING_ITEM'
const SET_ONBOARDING_NOTION_MODAL = 'SET_ONBOARDING_NOTION_MODAL'
const SET_ONBOARDING_NOTION_ITEM = 'SET_ONBOARDING_NOTION_ITEM'

export default {
  namespaced: true,

  state () {
    return {
      showOnboardingModal: false,
      currentOnboardingItem: null,
      showOnboardingNotionModal: false,
      currentOnboardingNotionItem: null
    }
  },

  getters: {
    showOnboardingModal: (state) => state.showOnboardingModal,
    currentOnboardingItem: (state) => state.currentOnboardingItem,
    showOnboardingNotionModal: (state) => state.showOnboardingNotionModal,
    currentOnboardingNotionItem: (state) => {
      return state.currentOnboardingNotionItem
    }
  },

  mutations: {
    [SET_ONBOARDING_MODAL] (state, value) {
      state.showOnboardingModal = value
    },

    [SET_ONBOARDING_ITEM] (state, item) {
      state.currentOnboardingItem = item
    },

    [SET_ONBOARDING_NOTION_MODAL] (state, value) {
      state.showOnboardingNotionModal = value
    },

    [SET_ONBOARDING_NOTION_ITEM] (state, item) {
      state.currentOnboardingNotionItem = item
    }
  },

  actions: {
    openOnboardingModal ({ commit }, item = null) {
      if (item) {
        commit(SET_ONBOARDING_ITEM, item)
      }
      commit(SET_ONBOARDING_MODAL, true)
    },

    openOnboardingNotionModal ({ commit }, item = null) {
      if (item) {
        commit(SET_ONBOARDING_NOTION_ITEM, item)
      }
      commit(SET_ONBOARDING_NOTION_MODAL, true)
    },

    closeOnboardingModal ({ commit }) {
      commit(SET_ONBOARDING_MODAL, false)
      commit(SET_ONBOARDING_ITEM, null)
    },

    closeOnboardingNotionModal ({ commit }) {
      commit(SET_ONBOARDING_NOTION_MODAL, false)
      commit(SET_ONBOARDING_NOTION_ITEM, null)
    }
  }
}
